module.exports = __webpack_public_path__ + "img/college_icon2.a328fef.png";